import { CustomerEntryName } from '../../utils/step-engine-constants';
import { StepList } from './step-engine-state';

export const SET_CURRENT_STEP = 'stepEngine/SET_CURRENT_STEP';
export const SET_CURRENT_REPEATABLE_STEP_GROUP = 'stepEngine/SET_CURRENT_REPEATABLE_STEP_GROUP';
export const ADD_NEXT_STEP_TO_STEP_LIST = 'stepEngine/ADD_NEXT_STEP_TO_STEP_LIST';
export const ADD_COMPONENT_DATA_TO_ONE_STEP = 'stepEngine/ADD_COMPONENT_DATA_TO_ONE_STEP';
export const DECREMENT_INSURED_GROUP_INDEX_COMPONENT = 'stepEngine/DECREMENT_INSURED_GROUP_INDEX_COMPONENT';
export const ADD_STEP_GROUP_TO_ONE_STEP = 'stepEngine/ADD_STEP_GROUP_TO_ONE_STEP';
export const REMOVE_STEP_FROM_STEP_LIST = 'stepEngine/REMOVE_STEP_FROM_STEP_LIST';
export const REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME = 'stepEngine/REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME';
export const REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX = 'stepEngine/REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX';
export const REMOVE_INSURED_GOOD_BY_INDEX = "stepEngine/REMOVE_INSURED_GOOD_BY_INDEX";
export const REMOVE_INSURED_GROUP_BY_INDEX = "stepEngine/REMOVE_INSURED_GROUP_BY_INDEX";
export const SET_COMPONENT_LIST = 'stepEngine/SET_COMPONENT_LIST';
export const SET_STEP_ENGINE_SUBSCRIPTION = 'stepEngine/SET_STEP_ENGINE_SUBSCRIPTION';
export const SET_STEP_ENGINE_SUBSCRIBER = 'stepEngine/SET_STEP_ENGINE_SUBSCRIBER';
export const SET_STEP_ENGINE_CREATED_CLAIM = 'stepEngine/SET_STEP_ENGINE_CREATED_CLAIM';
export const SET_COVER = 'stepEngine/SET_COVER';
export const SET_COVER_DISPLAY_NAME = 'stepEngine/SET_COVER_DISPLAY_NAME';
export const SET_CUSTOMER_ENTRY = 'stepEngine/SET_CUSTOMER_ENTRY';
export const ADD_CUSTOMER_ENTRY = 'stepEngine/ADD_CUSTOMER_ENTRY';
export const REMOVE_CUSTOMER_ENTRY = 'stepEngine/REMOVE_CUSTOMER_ENTRY';
export const ADD_GLOBAL_DATA = 'stepEngine/ADD_GLOBAL_DATA';
export const ADD_REPEATABLE_GLOBAL_DATA = 'stepEngine/ADD_REPEATABLE_GLOBAL_DATA';
export const REMOVE_REPEATABLE_GLOBAL_DATA = 'stepEngine/REMOVE_REPEATABLE_GLOBAL_DATA';
export const REMOVE_GLOBAL_DATA = 'stepEngine/REMOVE_GLOBAL_DATA';
export const REMOVE_DECLARATION_GLOBAL_DATA = 'stepEngine/REMOVE_DECLARATION_GLOBAL_DATA';
export const REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA = 'stepEngine/REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA';
export const RESET_STEP_ENGINE = 'stepEngine/RESET_STEP_ENGINE';
export const SET_BACK_TO_HOME = 'stepEngine/SET_BACK_TO_HOME';
export const SET_GO_TO_LOGIN_ERROR = 'stepEngine/SET_GO_TO_LOGIN_ERROR';
export const SET_SHOW_ELIGIBILITY_MODAL = 'stepEngine/SET_SHOW_ELIGIBILITY_MODAL';
export const SET_SHOW_ERROR_MODAL = 'stepEngine/SET_SHOW_ERROR_MODAL';
export const SET_SHOW_STEP_ACTION = 'stepEngine/SET_SHOW_STEP_ACTION';
export const SET_STEP_GROUP = 'stepEngine/SET_STEP_GROUP';
export const SET_DONT_SHOW_POPUP_REDIRECT_URL = 'stepEngine/SET_DONT_SHOW_POPUP_REDIRECT_URL';
export const SET_ADDITIONAL_STEP = 'stepEngine/SET_ADDITIONAL_STEP';
export const SET_RECEIVED_STEP = 'stepEngine/SET_RECEIVED_STEP';
export const SET_DISABLED_NEXT_BUTTON = 'stepEngine/SET_DISABLED_NEXT_BUTTON';
export const SET_STEP_ENGINE_DEVICE_TYPE = 'stepEngine/SET_STEP_ENGINE_DEVICE_TYPE';
export const SET_SHOW_RATING_MODAL = 'stepEngine/SET_SHOW_RATING_MODAL';
export const SET_LAST_EDIT_STEP = 'stepEngine/SET_EDIT_LAST_STEP';
export const SET_CURRENT_STEP_GROUP = 'stepEngine/SET_CURRENT_STEP_GROUP'
export const SET_LAST_REPEATABLE_STEP_GROUP = 'stepEngine/SET_LAST_REPEATABLE_STEP_GROUP';
export const DECREMENT_LAST_REPEATABLE_STEP_GROUP = 'stepEngine/DECREMENT_LAST_REPEATABLE_STEP_GROUP';
export const DECREMENT_CURRENT_REPEATABLE_STEP_GROUP = 'stepEngine/DECREMENT_CURRENT_REPEATABLE_STEP_GROUP';

export interface SetRecivedStep {
  type: typeof SET_RECEIVED_STEP;
  payload: string[];
}
export interface SetCurrentStep {
  type: typeof SET_CURRENT_STEP;
  payload: string[];
}

export interface SetCurrentRepeatableStepGroup {
  type: typeof SET_CURRENT_REPEATABLE_STEP_GROUP;
  payload: number;
}

export interface AddNextStepToStepList {
  type: typeof ADD_NEXT_STEP_TO_STEP_LIST;
  payload: {
    step: StepList,
    currentIndex: number,
  };
}

export interface AddComponentDataToOneStep {
  type: typeof ADD_COMPONENT_DATA_TO_ONE_STEP;
  payload: {
    currentIndex: number,
    component: {},
  };
}

export interface DecrementInsuredGroupIndexComponent {
  type: typeof DECREMENT_INSURED_GROUP_INDEX_COMPONENT;
  payload: {
    stepIndex: number,
  };
}

export interface AddStepGroupToOneStep {
  type: typeof ADD_STEP_GROUP_TO_ONE_STEP;
  payload: {
    currentIndex: number,
    stepGroup: string,
  };
}

export interface RemoveStepFromStepList {
  type: typeof REMOVE_STEP_FROM_STEP_LIST;
  payload: number;
}

export interface RemoveStepFromStepListByIndexAndName {
  type: typeof REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME;
  payload: {
    index: number,
    stepName: string,
  };
}

export interface RemoveStepsFromStepListAfterIndex {
  type: typeof REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX;
  payload: number;
}

export interface RemoveInsuredGoodByIndex {
  type: typeof REMOVE_INSURED_GOOD_BY_INDEX;
  payload: {
    index: number,
  };
}

export interface RemoveInsuredGroupByIndex {
  type: typeof REMOVE_INSURED_GROUP_BY_INDEX;
  payload: {
    index: number,
  };
}

export interface SetComponentList {
  type: typeof SET_COMPONENT_LIST;
  payload: {
    views: Map<any, any>
  }
}

export interface SetCurrentStepGroup {
  type: typeof SET_CURRENT_STEP_GROUP;
  payload: string;
}

export interface SetLastEditStep {
  type: typeof SET_LAST_EDIT_STEP;
  payload: string;
}

export interface SetSubscription {
  type: typeof SET_STEP_ENGINE_SUBSCRIPTION;
  payload: any;
}

export interface SetSubscriber {
  type: typeof SET_STEP_ENGINE_SUBSCRIBER;
  payload: any;
}

export interface SetCreatedClaim {
  type: typeof SET_STEP_ENGINE_CREATED_CLAIM;
  payload: any;
}
export interface SetCover {
  type: typeof SET_COVER;
  payload: string;
}

export interface SetCoverDisplayName {
  type: typeof SET_COVER_DISPLAY_NAME;
  payload: string;
}

export interface SetCustomerEntry {
  type: typeof SET_CUSTOMER_ENTRY;
  payload: { [id: string]: string };
}

export interface AddCustomerEntry {
  type: typeof ADD_CUSTOMER_ENTRY;
  payload: { customerEntryName: CustomerEntryName; value: any };
}

export interface RemoveCustomerEntry {
  type: typeof REMOVE_CUSTOMER_ENTRY;
  payload: { customerEntryName: CustomerEntryName };
}

export interface AddGlobalData {
  type: typeof ADD_GLOBAL_DATA;
  payload: { key: string; value: any };
}

export interface AddRepeatableGlobalData {
  type: typeof ADD_REPEATABLE_GLOBAL_DATA;
  payload: { key: string; value: any; repeatableStepGroupIndex: number };
}

export interface RemoveRepeatableGlobalData {
  type: typeof REMOVE_REPEATABLE_GLOBAL_DATA;
  payload: { key: string; repeatableStepGroupIndex: number };
}

export interface RemoveGlobalData {
  type: typeof REMOVE_GLOBAL_DATA;
  payload: { key: string };
}

export interface RemoveDeclarationGlobalData {
  type: typeof REMOVE_DECLARATION_GLOBAL_DATA;
  payload: { key: string };
}

export interface RemoveRepeatableDeclarationGlobalData {
  type: typeof REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA;
  payload: { insuredGroupIndex: number };
}

export interface ResetStepEngine {
  type: typeof RESET_STEP_ENGINE;
}

export interface SetBackToHome {
  type: typeof SET_BACK_TO_HOME;
  payload: boolean;
}

export interface SetGoToLoginError {
  type: typeof SET_GO_TO_LOGIN_ERROR;
  payload: boolean;
}

export interface SetShowEligibilityModal {
  type: typeof SET_SHOW_ELIGIBILITY_MODAL;
  payload: boolean;
}

export interface SetShowErrorModal {
  type: typeof SET_SHOW_ERROR_MODAL;
  payload: boolean;
}

export interface SetShowStepAction {
  type: typeof SET_SHOW_STEP_ACTION;
  payload: boolean;
}

export interface SetStepGroup {
  type: typeof SET_STEP_GROUP;
  payload: string;
}

export interface SetDontShowPopupRedirectUrl {
  type: typeof SET_DONT_SHOW_POPUP_REDIRECT_URL;
  payload: boolean;
}
export interface SetStepEngineDeviceType {
  type: typeof SET_STEP_ENGINE_DEVICE_TYPE;
  payload: string;
}

export interface SetShowRatingModal {
  type: typeof SET_SHOW_RATING_MODAL;
  payload: boolean;
}

export interface SetDisabledNextButton {
  type: typeof SET_DISABLED_NEXT_BUTTON;
  payload: { stepIndex: number; disableNextButton: boolean };
}

export interface SetLastRepeatableStepGroup {
  type: typeof SET_LAST_REPEATABLE_STEP_GROUP;
  payload: { lastRepeatableStepGroup: number; }
}

export interface DecrementLastRepeatableStepGroup {
  type: typeof DECREMENT_LAST_REPEATABLE_STEP_GROUP;
}

export interface DecrementCurrentRepeatableStepGroup {
  type: typeof DECREMENT_CURRENT_REPEATABLE_STEP_GROUP;
}

// --- Create Union Type

export type ActionsTypes =
  | SetCurrentStep
  | SetCurrentRepeatableStepGroup
  | AddNextStepToStepList
  | AddComponentDataToOneStep
  | AddStepGroupToOneStep
  | RemoveStepFromStepList
  | RemoveStepFromStepListByIndexAndName
  | RemoveStepsFromStepListAfterIndex
  | RemoveInsuredGoodByIndex
  | RemoveInsuredGroupByIndex
  | SetComponentList
  | SetLastEditStep
  | SetSubscription
  | SetSubscriber
  | SetCreatedClaim
  | SetCover
  | SetCoverDisplayName
  | SetCustomerEntry
  | AddCustomerEntry
  | RemoveCustomerEntry
  | ResetStepEngine
  | SetBackToHome
  | SetGoToLoginError
  | SetShowEligibilityModal
  | SetShowErrorModal
  | AddGlobalData
  | AddRepeatableGlobalData
  | RemoveRepeatableGlobalData
  | RemoveGlobalData
  | RemoveDeclarationGlobalData
  | RemoveRepeatableDeclarationGlobalData
  | SetShowStepAction
  | SetRecivedStep
  | SetDisabledNextButton
  | SetStepGroup
  | SetDontShowPopupRedirectUrl
  | SetStepEngineDeviceType
  | SetShowRatingModal
  | SetCurrentStepGroup
  | SetLastRepeatableStepGroup
  | DecrementLastRepeatableStepGroup
  | DecrementCurrentRepeatableStepGroup
  | DecrementInsuredGroupIndexComponent;
